<template>
  <article
    class="summary"
    id="summary"
  >
    <div class="scrolling">

      <div class="dark-bg-mob">
        <div class="ep-link-wrapper">
          <a
            class="ep-home"
            :href="rtsData.url"
            target="_blank"
          >
            <img v-if="getT" src="../assets/images/logo-white.svg" v-bind:alt="getT.static.back_to_main_site" />
          </a>
        </div>

        <h2 class="austin responsive-content-column" id="contact-title" v-if="getT">{{getT.static.contact[0].contact_title}}</h2>
        
        <!-- only used for mobile & tablet -->
        <div id="form-screen-playcanvas-slot" class="responsive-content-column"></div> 
        
        <button class="back responsive-content-column" v-on:click="goBack()">
          <h3>{{ currPool.title }}</h3>
          <img src="../assets/icons/right-arrow-small.svg" />
          <span v-if="getT">
            {{ getT.static.summary[0].back_button_text }}</span
          >
        </button>
      </div>

      <p class="instruction responsive-content-column" v-if="getT">{{getT.static.contact[0].contact_instructions}}<sup>&dagger;</sup></p>

      <Contact />
    </div>
  </article>
</template>
<script>
import Contact from '../components/Contact';
import { mapGetters } from 'vuex';
import { breakpoint } from '../styles/style';

export default {
  name: 'SummaryView',
  computed: {
    ...mapGetters(['showPricing', 'rtsData', 'summaryAccessoryPricing', 'getT', 'currPool']),
  },
  components: {
    Contact,
  },
  data: function() {
    return {
      windowMode: 'desktop', // used by resize listener, so we know when we are changing between 'desktop' & 'mobile'
      showAccessories: false,
      showDropdown: false,
    };
  },
  mounted: function() {
    /* 
      we leave the playcanvas component as a child of the app component, for desktop.
      for phone/tablet, when on the form screen, the playcanvas component is made child of an element 
      in this page so that it scrolls. 
    */
    if (document.body.clientWidth <= breakpoint.xl) { 
      // 440ms is how long the animation is to resize PlayCanvas window
      setTimeout(() => {
        // check that we're still on this page
        // fixes issue in which error's thrown if user refreshes on summary screen (because that redirects to customizer)
        if (this.$router.currentRoute.value.path === '/summary') {
          window.moveCanvasToSummary();
          this.windowMode = 'mobile';
        }
      }, 440);
    }

    // call method set in playcanvas project to set the camera angle, if the scene has loaded
    window.showSummaryView?.();
    // moving playcanvas element from one page to another, need new frame to fix aspect ratio. need delay due to transition
    setTimeout(() => {
      if (window.RenderCenter)
      {
        window.RenderCenter.renderRequested = true;
      }
    }, 450);
    
    window.addEventListener('resize', this.resizeListener);
    window.addEventListener('orientationchange', this.resizeListener);
  },
  beforeUnmount() {
    // don't accumulating duplicate event listeners if user navigates to and from component repeatedly
    window.removeEventListener('resize', this.resizeListener);
    window.removeEventListener('orientationchange', this.resizeListener);
  },
  methods: {
    gotoRoot() {
      window.location.href = this.rtsData.url;
    },
    resizeListener(e) {
      if (e.target.innerWidth > breakpoint.xl && this.windowMode == 'mobile') {
        window.moveCanvasOutOfSummary();
        this.windowMode = 'desktop';
      } else if (e.target.innerWidth <= breakpoint.xl && this.windowMode == 'desktop') {
        window.moveCanvasToSummary();
        this.windowMode = 'mobile';
      }
    },
    goBack: function () {
      this.$router.push('/customizer');
    },
  },
};

/*
  PlayCanvas component gets moved in/out of form screen scrolling container:
      /customizer                 - canvas is absolute position
      /summary (desktop)          - canvas is absolute position
      /summary (mobile/tablet)    - canvas is part of the scrolling summary content
*/
window.moveCanvasToSummary = function() {
  let newParent = document.querySelector('#form-screen-playcanvas-slot');
  let canvas = document.querySelector('#play-canvas'); 
  if (
    typeof newParent != 'undefined' &&
    newParent != null &&
    typeof canvas != 'undefined' &&
    canvas != null
  ) {
    newParent.prepend(canvas);
  }
}
// called from Vue Router hook
window.moveCanvasOutOfSummary = function() {
  const newParent = document.querySelector('#app');
  const canvas = document.querySelector('#play-canvas');

  if (
    typeof newParent != 'undefined' &&
    newParent != null &&
    typeof canvas != 'undefined' &&
    canvas != null
  ) {
    newParent.appendChild(canvas);
  } 

  // moving playcanvas element from one page to another, need new frame to fix aspect ratio. need delay due to transition
  setTimeout(() => {
    if (window.RenderCenter)
      {
        window.RenderCenter.renderRequested = true;
      }
  }, 450);
}
</script>
<style lang="scss">
sup {
  vertical-align: top; 
  position: relative; 
  top: -0.5em;
  font-size: 0.8em;
}
article.summary {
  position: absolute;
  top: 0;
  z-index: 11;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-color: $deep-navy;
  transition: z-index 200ms linear;
  .ep-link-wrapper {
    width: unset;
    padding: 1.5em 1.5em 1em;
    a {
      cursor: pointer;
    }
  }
  .scrolling {
    background-color: $navy;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    h2 {
      font-size: 2rem;
      letter-spacing: 0.86px;
      color: white;
      margin-bottom: 13px;
    }
    #form-screen-playcanvas-slot {
      padding: 1em 1.5em;
      min-height:20em;
      #play-canvas { // only applies for 'mobile' windowMode because the el is not located here for desktop
        position: relative;
        top: 0;
        left: 0;
        width: 100%;
        pointer-events: none;
        button {
          display: none;
        }
      }
    }
    button.back {
      z-index: 100;
      text-align: left;
      letter-spacing: 0;
      background: transparent;
      border: none;
      transition: none;
      user-select: none;
      font-family: 'Europa Regular';
      font-size: 1rem;
      margin-bottom: 1.5rem;
      margin-top: 0.2rem;
      padding-bottom: 0;
      padding-top: 0;
      cursor: pointer;
      span {
        letter-spacing: 0.1em;
      }
      h3 {
        color: #fff;
        font-family: 'Austin Bold', serif;
        text-transform: none;
        font-size: 1.625rem;
        margin-bottom: 0.1em;
      }
      img {
        transform: rotate(180deg);
        margin-bottom: -0.1em;
      }
    }
    .instruction {
      font-size: 1.125rem;
      line-height: 1.375em;
      color: white;
      margin-bottom: 8px;
    }
    .responsive-content-column {
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }
  }
  @media #{ $desktop } {
    #form-screen-playcanvas-slot {
      display: none;
    }
    .ep-link-wrapper {
      position: fixed;
      z-index: 60;
      padding: 0;
      top: 1.5em;
      left: 2em;
    }
    .scrolling {
      padding-top: 6rem;
      height: 100%;
      width: 100%;
      display: -webkit-flex;
      display: flex;
      align-items: flex-end;
      flex-direction: column;
      /*
        the page design specifies background colors 
        that stretch the full width of the screen on desktop, while the content is confined to a 
        column at the right side of the screen. 
        the 'responsive-content-column' class is for content elements.
      */
      .responsive-content-column {
        width: 30rem;
        min-width: 30vw;
      }
      section.summary {
        padding-top: 2em;
      }
      button.back {        
        position: fixed;
        top: 6rem;
        left: 2em;
      }
    }
  }
  @media #{ $phablet } {
    .dark-bg-mob {
      background-color: $deep-navy;
      margin-bottom: 2rem;
    }
  }
}
</style>
